import searchService from '@/services/shared/search/searchApiService.js';

export const performSearch = async (context, { searchForm, searchType, searchArchived }) => {
  context.commit('resetSearchResults');

  var res = await searchService.search({ searchFields: searchForm, searchArchived: searchArchived });
  if (res.code !== 0 && res.code !== 2) {
    context.commit('setError', res.message, { root: true });
    return;
  }

  context.commit('setSearchResult', { searchResult: res.data[0], searchType: searchType });
};

export const addToSearchHistory = (context, searchInfo) => {
  context.commit('addToSearchHistory', searchInfo);
};

export const clearSearchResults = (context) => {
  context.commit('resetSearchResults');
};

export const resetSearch = (context) => {
  context.commit('clearSearch');
};
